import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs/index';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ApiReportsService } from '@core/services/entities/reports/api-reports.service';
import {
  LoadAction,
  LoadFailureAction,
  LoadSuccessAction,
  WikiReadersReportActionTypes,
} from './wiki-readers-report.actions';

@Injectable()
export class WikiReadersReportEffects {
  constructor(
    private actions$: Actions,
    private apiReportsService: ApiReportsService,
  ) {
  }

  @Effect()
  load$ = this.actions$.pipe(
    ofType(WikiReadersReportActionTypes.LoadAction),
    switchMap((action: LoadAction) =>
      this.apiReportsService
        .getWikiArticleReaders(action.wikiId, action.params)
        .pipe(
          map((response) => new LoadSuccessAction(action.wikiId, response.data || [])),
          catchError((errors) => of(new LoadFailureAction(action.wikiId, errors)))
        )
    )
  );
}
